import { signInWithCustomToken } from 'firebase/auth';

import { auth } from '@src/firebase/firebase';
import type {
  EmailPinCodeAccessParams,
  EmailPinCodeAccessResult,
  EmailPinSendParams,
  EmailPinSendResult,
} from '@src/models/interfaces/emailPin.interface';
import { set } from '@src/packages/utils/storage';
import { apiCallable } from '@src/util/cloud-functions/apiClient';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

class EmailPinRepository {
  async sendPin(params: EmailPinSendParams): Promise<EmailPinSendResult> {
    const sendPinFn = apiCallable<EmailPinSendParams, EmailPinSendResult>(
      API_OPERATIONS.EMAIL_PIN_SEND_PIN,
    );
    const response = await sendPinFn(params);
    return response.data;
  }

  async codeAccess(params: EmailPinCodeAccessParams): Promise<EmailPinCodeAccessResult> {
    const codeAccessFn = apiCallable<EmailPinCodeAccessParams, EmailPinCodeAccessResult>(
      API_OPERATIONS.EMAIL_PIN_CODE_ACCESS,
    );
    const response = await codeAccessFn(params);
    return response.data;
  }

  async signInWithCustomToken(token: string): Promise<string | null> {
    const { user } = await signInWithCustomToken(auth, token);
    if (!user?.uid) {
      return null;
    }

    set('user_id', user.uid);
    return user.uid;
  }
}

export default EmailPinRepository;
